import React from 'react';
import { Table, TableBody, TableRow, TableCell } from '@material-ui/core';

import formatters from '../../../../formatters';

class ShareInfo extends React.Component {
    render() {
        const { currentShare } = this.props;

        return (
            <>
                <Table>
                    <TableBody>
                        <TableRow>
                            <TableCell>Recipients</TableCell>
                            <TableCell align="right">
                                {currentShare.recipient_count}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Last updated</TableCell>
                            <TableCell align="right">
                                {formatters.date(
                                    currentShare.last_modified_date
                                )}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>Owner</TableCell>
                            <TableCell align="right">
                                {currentShare.owner}
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </>
        );
    }
}
export default ShareInfo;
